import {useState} from 'react'
import {Link} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
import FormErrors, {DEFAULT_AUTH_ERROR} from '../components/FormErrors'
import {login} from '../lib/allauth'
import {useConfig} from '../auth'
import ProviderList from '../socialaccount/ProviderList'

function isLoginSuccess (content) {
    return content?.status === 200 && content?.meta?.is_authenticated === true
}

function loginFallbackMessage (content) {
    if (!content || isLoginSuccess(content)) {
        return undefined
    }
    return DEFAULT_AUTH_ERROR
}

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [response, setResponse] = useState({fetching: false, content: null})
    const config = useConfig()
    const hasProviders = config.data.socialaccount?.providers?.length > 0

    function submit() {
        setResponse({...response, fetching: true})
        const payload = {password};
        if (email.indexOf("@") > -1) {
            payload.email = email;
        } else {
            payload.username = email;
        }
        login(payload).then((content) => {
            setResponse((r) => {
                return {...r, content}
            })
        }).catch((e) => {
            console.error(e)
            setResponse((r) => ({
                ...r,
                content: {
                    status: 0,
                    errors: [{
                        message: 'Unable to reach the server. Please check your connection and try again.',
                        param: null
                    }]
                }
            }))
        }).then(() => {
            setResponse((r) => {
                return {...r, fetching: false}
            })
        })
    }

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            submit();
        }
    }

    const fallbackMessage = loginFallbackMessage(response.content)

    return (
        <div className={'centeredForm'}>

            <FormErrors errors={response.content?.errors} fallbackMessage={fallbackMessage}/>

            <div>
                <label>Email / Username</label>
                <div>
                    <input value={email}
                           onChange={(e) => setEmail(e.target.value)}
                           onKeyDown={handleKeyDown}
                           type='email'
                           required/>
                </div>
                <FormErrors param='email' errors={response.content?.errors}/>
                <FormErrors param='username' errors={response.content?.errors}/>
            </div>
            <div>
                <label>Password</label>
                <div className="password-input-wrapper">
                    <input value={password}
                           onChange={(e) => setPassword(e.target.value)}
                           onKeyDown={handleKeyDown}
                           type={showPassword ? 'text' : 'password'}
                           required/>
                    <button
                        type="button"
                        className="password-toggle"
                        onClick={() => setShowPassword((visible) => !visible)}
                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye}/>
                    </button>
                </div>
                <FormErrors param='password' errors={response.content?.errors}/>
            </div>

            <div className={'fieldLogin'}>
                <button disabled={response.fetching} onClick={() => submit()}>Login</button>
                <Link to={'/account/password/reset'}>Forgot your password?</Link>

            </div>

            <hr/>

            {hasProviders &&
                <div className={'socialProviders'}><ProviderList callbackURL='/account/provider/callback'/></div>}
        </div>
    )
}
